import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import Grid from '@material-ui/core/Grid';
import {ConfigurationsAreaEditorComponent} from '../configurations-area-editor/configurations-area-editor.component';
import {observer} from 'mobx-react';
import Paper from '@material-ui/core/Paper';



@observer
export class ConfigurationsEditorComponent extends LauncherComponentBase<{}> {

    render() {

        let areas = this.services.configurationsAreas.areas;
        let batchSize = Math.max(7,  Math.min(...areas.map(area => area.fields.length)));
        return (
            <Paper>
                <Grid container justify="flex-start" spacing={2}>
                    {areas.map(area => {
                        return (
                            <Grid item key={area.title}>
                                <ConfigurationsAreaEditorComponent title={area.title} fields={area.fields} batchSize={batchSize}/>
                            </Grid>
                        );
                    })}
                </Grid>
            </Paper>
        )
    }
}